// extracted by mini-css-extract-plugin
module.exports =  {"container":"_32bbee5fda--container--Hm4dV","container--multiple-phones":"_32bbee5fda--container--multiple-phones--HThfd"};